import { router } from "../router/";
import eventBus from './eventBus';
import { alert } from './alerts';

// Pulls a human-readable message out of an error response. The backend's
// GlobalExceptionHandler wraps 422 / 409 / 400 as {message: "..."}, but a few
// controllers still return a bare string body (e.g. /sales/{id}/fulfill).
const extractMessage = (response) => {
    const data = response?.data;
    if (!data) return null;
    if (typeof data === 'string') return data;
    return data.message || data.error || null;
}

// Returns true when the status was handled (navigated, prompted, or alerted),
// false when the caller has to deal with it themselves.
const validate_status = (response, dashboard = false) => {
    if (response.status == 401) {
        eventBus.emit('show-login-modal');
        return true;
    }
    if (response.status == 404) {
        router.push({ name: dashboard ? '404_dashboard' : '404' });
        return true;
    }
    if (response.status == 403) {
        router.push({ name: dashboard ? '403_dashboard' : '403' });
        return true;
    }
    if (response.status == 500) {
        router.push({ name: dashboard ? '500_dashboard' : '500' });
        return true;
    }

    // Any other 4xx — 422 BusinessRuleViolationException, 409
    // InvalidSaleStateException, 400 validation — carries a message written
    // to be read by the user. Surface it instead of dropping it on the floor.
    if (response.status >= 400 && response.status < 500) {
        alert.error(extractMessage(response) || 'The request could not be completed. Please review and try again.');
        return true;
    }

    return false;
}

export const handler = (err, dashboard = false) => {
    if (err.response)
        return validate_status(err.response, dashboard)
    else if (err.request) {
        router.push({ name: 'No Internet' })
        return true;
    } else {
        router.push({ name: dashboard ? '500_dashboard' : '500' })
        return true;
    }
}
